<h1 class="text-center">{{ 'SELLER_COLLECT_DATA.HEADER.BUSINESS_DETAILS' | translate }}</h1>
<p class="text-center">{{ 'SELLER_COLLECT_DATA.TEXT.COMPLETE_FORM_DISCLAIMER' | translate }}</p>

<form [formGroup]="formGroup" (ngSubmit)="submit()" class="flex flex-column gap-3">
  <div class="flex flex-column gap-2">
    <label for="bankCode">{{ 'SELLER_COLLECT_DATA.LABEL.BANK_NAME' | translate }}</label>
    <p-dropdown
      *ngIf="cs.banks$ | async as banks"
      styleClass="w-12"
      id="bankCode"
      formControlName="bankCode"
      optionValue="code"
      [options]="banks"
      [filter]="true"
      filterBy="localName,internationalName"
    >
      <ng-template let-item pTemplate="selectedItem">
        <div class="flex align-items-center gap-2" *ngIf="item">
          <div>{{ item.code }} - {{ item | appDictionaryItemTranslate | async }}</div>
        </div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item.code }} - {{ item | appDictionaryItemTranslate | async }}</div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>

  <div class="flex flex-column gap-2">
    <label for="bankBranch">{{ 'SELLER_COLLECT_DATA.LABEL.BANK_BRANCH' | translate }}</label>
    <input pInputText formControlName="bankBranch" id="bankBranch" />
  </div>

  <div class="flex flex-column gap-2">
    <label for="bankAccount">{{ 'SELLER_COLLECT_DATA.LABEL.BANK_ACCOUNT' | translate }}</label>
    <input pInputText formControlName="bankAccount" id="bankAccount" />
  </div>

  <div class="terms-checkbox">
    <p-checkbox [binary]="true" formControlName="terms" />
    <div [innerHTML]="'SELLER_COLLECT_DATA.LABEL.TERMS' | translate"></div>
  </div>

  <div class="flex justify-content-between">
    <button pButton pRipple (click)="goBack()" type="button" icon="pi pi-arrow-left" class="p-button-rounded"></button>
    <button pButton class="simple-button w-9" [disabled]="formGroup.invalid">
      {{ 'SELLER_COLLECT_DATA.LABEL.CONTINUE' | translate }}
    </button>
  </div>
</form>
